import {
  Button,
  Divider,
  ModalHeader,
  Alert,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  AlertIcon,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';

type ConvertAndUnlinkModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
};

export default function ConvertAndUnlinkModal({
  isOpen,
  onClose,
  onSubmit,
}: ConvertAndUnlinkModalProps): React.ReactElement {
  const [isSubmitting, setSubmitting] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const onSubmitInternal = async () => {
    setSubmitting(true);
    await onSubmit();
    setSubmitting(false);
    onClose();
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
      size="lg"
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <ModalHeader>Convert and unlink elements</ModalHeader>
        <Divider orientation="horizontal" />
        <AlertDialogBody marginX={2}>
          Are you sure you want to unlink the selected elements?
          <Alert mt={2} status="warning">
            <AlertIcon />
            The existing dynamic links will be converted to manual links in the
            process.
          </Alert>
        </AlertDialogBody>
        <Divider orientation="horizontal" />
        <AlertDialogFooter gap={2}>
          <Button
            onClick={onSubmitInternal}
            isLoading={isSubmitting}
            variant="outline"
            colorScheme="red"
          >
            Convert and unlink
          </Button>
          <Button colorScheme="gray" onClick={onClose}>
            Cancel
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
